import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../../../components/loading/loading.js';

const NewsDetailPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "news-detail-page" */'./news-detail.page.js'),
	modules: ['./news-detail.page.js'],
	webpack: () => [require.resolveWeak('./news-detail.page.js')],
	loading: CustomLoadableLoading,
});

export default NewsDetailPageAsync;
